
import Vue from 'vue';
import Button from '@/components/Button/index.vue';
import Modal from '@/components/Modal/index.vue';
import { createReportTerm, CreateReportTermParams } from '@/services/territory/create-report-term';
import { insertConstestation, InsertRegisterParams } from '@/services/contestation/insert-contestation-register';
import { updateStatusTerritoryOfficial } from '@/services/territory/update-status-territory-oficial';
import { initBlipChat } from '@/utils/blip-chat';
import getTerritoryByIdService from '@/services/territory/get-territory-by-id';
import { updateStatusTerritory } from '@/services/territory/update-status-territory';
import RepresentativeModal from './RepresentativeModal/index.vue';
import RepresentativeRegisterModal from './RepresentativeRegisterModal/index.vue';

export default Vue.extend({
  inject: ['userLogged', 'getStepDate', 'resetStepsRegisterTerritory'],
  components: {
    Button,
    RepresentativeModal,
    RepresentativeRegisterModal,
    Modal,
  },
  data() {
    return {
      territory: {
        loaded: false,
        territoryEditionModal: false,
        agents: [{
          id: '',
        }],
        city: '',
        force: '',
        name: '',
        car: '',
        id: '',
        documents: [],
      },
      isOpenModalRepresentativeConfirmed: false,
      isOpenModalRegisterRepresentative: false,
      isOpenModalInfo: false,
      isOpenModalDetection: false,
      isContestation: false,
      isOpenModalContestation: false,
      isRefusal: false,
      loadingButtonInitContestation: false,
      isConditionContestation: false,
    };
  },
  methods: {
    onNextStep() {
      this.createReportTermRequest(false);
      this.getStepDate.currentStep += 1;
    },
    async createReportTermWithRetry(params: CreateReportTermParams, retries = 0, maxRetries = 5) {
      try {
        const response = await createReportTerm(params);
        console.log('response 12', response);
        if (response && !response.hasErrors) {
          console.log('Requisição bem-sucedida!');
          return response;
        }
        throw new Error('Erro na requisição: resposta não é válida.');
      } catch (error) {
        console.warn(`Tentativa ${retries + 1} falhou: ${error}`);
        if (retries < maxRetries) {
          // Aguarde antes de tentar novamente
          await new Promise((resolve) => setTimeout(resolve, 1000)); // 1 segundo de espera
          return this.createReportTermWithRetry(params, retries + 1, maxRetries);
        }
        console.error('Número máximo de tentativas atingido.');
        throw error;
      }
    },
    async createReportTermRequest(condition: boolean) {
      const {
        stName, stDocument, stEmail, stPhone,
      } = this.userLogged;
      const strAdress = `${this.getStepDate.address.address}, ${this.getStepDate.address.neighborhood}`;
      const params: CreateReportTermParams = {
        nameMain: stName,
        document: stDocument,
        tokenKey: this.userLogged.company.stKey,
        cdTerritory: this.getStepDate.territory.id,
        carNumber: this.getStepDate.territory.car.replaceAll('-', ''),
        territoryName: this.getStepDate.territory.name,
        street: strAdress,
        number: this.getStepDate.address.number,
        complement: this.getStepDate.address.complement,
        city: this.getStepDate.address.city,
        state: this.getStepDate.address.state,
        cep: this.getStepDate.address.zipCode,
        email: stEmail,
        telephone: stPhone,
        cdAgent: this.getStepDate.agent.id,
        representativeName: this.getStepDate.territory.representative.name === '' ? 'Não informado' : this.getStepDate.territory.representative.name,
        representativeDocumentNumber: this.getStepDate.territory.representative.document !== undefined ? this.getStepDate.territory.representative.document : '0',
        representativePosition: this.getStepDate.territory.representative.office !== undefined ? this.getStepDate.territory.representative.office : 'Não informado',
        isAssing: condition,
      };

      try {
        const data = await this.createReportTermWithRetry(params);
        this.getStepDate.term = { ...this.getStepDate.term, ...data };
      } catch (error) {
        console.error('Erro ao criar o termo de compromisso:', error);
      }
    },
    onSubmitRepresentive() {
      this.isOpenModalRegisterRepresentative = false;
      this.onNextStep();
    },
    onClickAccepted() {
      this.isOpenModalRepresentativeConfirmed = false;
      this.isOpenModalRegisterRepresentative = true;
      if (this.isContestation === true) {
        this.onCloseModalContestation();
      }
    },
    onClickNotAccepted() {
      this.isOpenModalRepresentativeConfirmed = false;
      if (this.isConditionContestation === false) {
        this.onNextStep();
      } else {
        this.onCloseModalContestation();
        this.$router.push('/produtor/territory');
      }
    },
    async onCloseModalDetection() {
      this.isOpenModalDetection = false;
    },
    openModalRefusal() {
      this.isRefusal = true;
    },
    returnHome() {
      this.$router.push('/produtor/territory');
    },
    async onCloseModalContestation() {
      this.isOpenModalContestation = false;
      this.loadingButtonInitContestation = true;
      await updateStatusTerritory(this.getStepDate.territory.id, true);
      const blipChat = document.getElementById('blip-chat-container');
      if (blipChat) blipChat.remove();
      initBlipChat(
        this.getStepDate.territory.id,
        this.getStepDate.territory.name,
        this.getStepDate.address.city,
        this.getStepDate.address.state,
      );
      this.loadingButtonInitContestation = false;
      if (this.isContestation === false) {
        this.$router.push('/produtor/territory');
      }
    },
    async getTerritoryByCarCode(id: string) {
      const { objectResult } = await getTerritoryByIdService(id);

      if (objectResult) this.territory = objectResult.dadosExtratoPdf;

      this.territory.loaded = true;
    },
    async startContestation() {
      const {
        stName, stDocument, stEmail, stPhone,
      } = this.userLogged;
      const strAdress = `${this.getStepDate.address.address}, ${this.getStepDate.address.neighborhood}`;
      const paramsTerm: CreateReportTermParams = {
        // @ts-ignore
        nameMain: stName,
        document: stDocument,
        tokenKey: this.userLogged.company.stKey,
        cdTerritory: this.getStepDate.territory.id,
        carNumber: this.getStepDate.territory.car.replaceAll('-', ''),
        territoryName: this.getStepDate.territory.name,
        street: strAdress,
        number: this.getStepDate.address.number,
        complement: this.getStepDate.address.complement,
        city: this.getStepDate.address.city,
        state: this.getStepDate.address.state,
        cep: this.getStepDate.address.zipCode,
        email: stEmail,
        telephone: stPhone,
        // @ts-ignore
        cdAgent: this.getStepDate.agent.id,
        representativeName: this.getStepDate.territory.representative.name === '' ? 'Não informado' : this.getStepDate.territory.representative.name,
        representativeDocumentNumber: this.getStepDate.territory.representative.document !== undefined ? this.getStepDate.territory.representative.document : '0',
        representativePosition: this.getStepDate.territory.representative.office !== undefined ? this.getStepDate.territory.representative.office : 'Não informado',
        isAssing: false,
      };
      await createReportTerm(paramsTerm).then((data) => {
        this.getStepDate.term = { ...this.getStepDate.term, ...data };
      });
      this.isOpenModalContestation = true;
      this.isConditionContestation = true;
      this.isOpenModalDetection = false;
      this.isOpenModalInfo = true;
      await this.getTerritoryByCarCode(this.getStepDate.territory.id);
      const resp = await getTerritoryByIdService(this.getStepDate.territory.id);
      const params: InsertRegisterParams = {
        territoryId: this.getStepDate.territory.id,
        tokenKey: this.userLogged.company.stKey,
        name: this.getStepDate.territory.name,
        status: 'Pendente',
        car: this.getStepDate.territory.car.replaceAll('-', ''),
        document: this.getStepDate.agent.document || '',
        city: resp.objectResult.city,
        nameProducer: this.userLogged.stName,
      };
      await Promise.all([
        insertConstestation(params),
        updateStatusTerritoryOfficial(this.getStepDate.territory.id, 'PROVISORIO'),
      ]);
    },
  },
});
